
import PlusCircleIcon from "./Icons/PlusCircleIcon.vue";
import MinusCircleIcon from "./Icons/MinusCircleIcon.vue";
import PageContent from "./PageContent.vue";
import DispatchEventUtils from "./Mixins/DispatchEventUtils.js";
import LoginRequired from "./LoginRequired.vue";


export default {
  name: "ExplanationMobile",
  components: {LoginRequired, MinusCircleIcon, PlusCircleIcon, PageContent},
  mixins: [DispatchEventUtils],
  inject:['isLogged'],
  props: {
    exp: Object,
    isText: Boolean,
    selectedOrder: {
      type: Array,
      default: () => []
    }
  },
  methods:{
    toggleShow(){
      this.dispatch('FileViewer', 'show-explanation', {page:this.$parent.$parent.source, order: this.exp.page_id, reset: false})
    }
  }
}
